import {dispatchTrackEvent} from "./_tracking";

export default function initResearch() {
  document.querySelectorAll('.research .readmore').forEach((more) => {
    more.addEventListener('click', (() => createModal(more.closest('article'))));
  });
}

function createModal(data) {
  const modal = document.createElement('div');
  modal.className = 'modal';
  modal.addEventListener('click', () => modal.remove());

  const modalContent = document.createElement('div');
  modalContent.className = 'content';

  const heading = data.querySelector('h2').cloneNode(true);
  const logo = data.querySelector('picture.logo').cloneNode(true);
  const text = data.querySelector('.full-text').cloneNode(true);
  text.classList.remove('hidden');

  modalContent.appendChild(logo);
  modalContent.appendChild(heading);
  modalContent.appendChild(text);

  modal.appendChild(modalContent);
  document.body.appendChild(modal);

  trackModal(modal, heading.innerText);
}

function trackModal(target, label) {
  dispatchTrackEvent({
    'eventCategory': 'modal',
    'eventAction': 'open',
    'eventLabel': label,
    'eventValue': 10,
    'nonInteraction': false,
  }, target);
}
